// @flow
import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { getUploadImageUrl, uploadFile } from '@data/api/upload'
import { IMAGE_FILE_TYPES } from '@utils/constants'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  onChange: (filename: string) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: (e: any) => void
}

const ImageUploader = ({ children, onChange, onError }: Props) => {
  const [ tmpImage, setTmpImage ] = useState(null)
  const [ isUploading, setUploading ] = useState(false)
  const [ progress, setProgress ] = useState(0)

  const onDrop = async ([ file ], rejected) => {
    if (rejected.length > 0) {
      // TODO: Alert message
      return
    }
    // first load preview
    const reader = new FileReader()
    reader.onloadend = () => setTmpImage(reader.result)
    reader.readAsDataURL(file)

    // then upload image
    setUploading(true)
    const { url, params } = await getUploadImageUrl(file.name, file.type)
    const uploader = uploadFile(url, file, params)
    uploader
      .progress(({ loaded, total }) => {
        const percent = (loaded / total) * 100
        setProgress(percent)
      })
      .then(() => {
        setProgress(100)
        setUploading(false)
        // setTmpImage(null)
        onChange(params.filename)
      })
      .catch((e) => {
        setUploading(false)
        onError(e)
      })
  }

  return (
    <Dropzone onDrop={onDrop} accept={IMAGE_FILE_TYPES} multiple={false}>
      {(args) => children(args, tmpImage, isUploading, progress)}
    </Dropzone>
  )
}

ImageUploader.defaultProps = {
  onError: (f) => f,
}

export default ImageUploader
